import { useEventCallback } from '@mui/material/utils';

import { Task } from '@work4all/models/lib/Classes/Task.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/task-table-schema.json';
import { TaskPriorityCell } from '../TaskPriorityCell';
import { TaskStatusCell } from '../TaskStatusCell';

import { useTaskBoard } from './use-task-board';

export type ITaskPriorityCellConfig = {
  type: 'TaskPriority';
};

export type ITaskStatusCellConfig = {
  type: 'TaskStatus';
  params: {
    ownerIdField: string;
  };
};

type ITaskTableCustomColumns = {
  TaskStatus?: ITaskStatusCellConfig;
  TaskPriority?: ITaskPriorityCellConfig;
};

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];
const forceRequestFields: Task = { status: null };

export function TasksTable(props: IEntityTableV8) {
  const { prefilter, ...board } = useTaskBoard({
    getTable: useEventCallback(() => dataTable.table),
  });

  const tableProps = {
    ...props,
    schema: schema as never,
    cells: {
      TaskStatus: TaskStatusCell,
      TaskPriority: TaskPriorityCell,
    },
    cellProcessors: {
      TaskStatus(config) {
        return [config.accessor, 'user.id'];
      },
    },
    defaultSort,
    forceRequestFields,
    enableURLState: false,
  };

  const dataTable = useEntityDataTableV8<Task, ITaskTableCustomColumns>({
    ...tableProps,
    prefilter,
    enableURLState: true,
  });

  const tableState = dataTable.table.getState();

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      board={{
        ...board,
        ...tableProps,
        columnFilters: tableState.columnFilters,
        grouping: tableState.grouping,
      }}
    />
  );
}
